var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "order_history_detail" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c(
            "div",
            { staticClass: "main_content" },
            [
              _c("dd-menu", { ref: "menuRef" }),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("dd-sitemap", {
                    attrs: {
                      pageKey: _vm.pageKey,
                      pageList: _vm.pageList,
                      mapStyle: "topic_path"
                    }
                  }),
                  _vm._v(" "),
                  _c("h1", [_vm._v("ご注文履歴詳細")]),
                  _vm._v(" "),
                  _c("dd-history-detail", { attrs: { orderNo: _vm.orderNo } })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("dd-footer")
        ],
        1
      ),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c492c9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c492c9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcOrderHistoryDetail.vue
// module id = null
// module chunks = 